import { darken, lighten, makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => {
    const isLightMode = theme.palette.type === Theme.Light;
    return {
        root: {
            paddingTop: theme.spacing(4),
            [theme.breakpoints.down('sm')]: {
                paddingTop: theme.spacing(2),
            },
        },
        rightSide: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        content: {
            padding: '0 0px',
            paddingRight: theme.spacing(3),
            fontWeight: 400,
            color: isLightMode ? '#222' : '#eee',
            [theme.breakpoints.down('sm')]: {
                paddingRight: 0,
            },
            '& strong': {
                fontWeight: 600,
            },
            '& a': {
                color: theme.palette.primary.main,
                transition: '.2s',
                '&:hover': {
                    color: lighten(theme.palette.primary.main, 0.2),
                },
                '&:active': {
                    color: darken(theme.palette.primary.main, 0.2),
                },
            },
            '& ul': {
                paddingInlineStart: '20px',
            },
            '& li::marker': {
                color: theme.palette.primary.main,
            },
        },
        bookmark: {
            position: 'absolute',
            right: theme.spacing(3),
            top: 0,
            transform: 'translate(-50%,-50%)',
            '& .MuiIconButton-root': {
                backgroundColor: isLightMode ? 'rgb(255,255,255)' : 'rgb(42,42,42)',
                boxShadow: theme.shadows[1],
                '& svg': {
                    fontSize: '1.75rem',
                },
            },
            [theme.breakpoints.down('xs')]: {
                right: theme.spacing(0),
            },
        },
        contentSection: {
            ...theme.typography.body1,
            width: '100%',
            marginBottom: '30px',
            padding: 0,
            '& *': {
                color: isLightMode ? '#333 !important' : '#FFF !important',
            },
        },
        summary: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        sideSection: {
            display: 'flex',
            width: '100%',
            marginBottom: '20px',
        },
        searchButton: {
            padding: '18px 20px',
            fontSize: '20px',
        },
        button: {
            height: 60,
            fontSize: 20,
            textTransform: 'none',
            [theme.breakpoints.down('md')]: {
                height: 50,
                fontSize: 16,
            },
        },
    };
});
